import script from "./list.vue?vue&type=script&setup=true&lang=js"
export * from "./list.vue?vue&type=script&setup=true&lang=js"

import "./list.vue?vue&type=style&index=0&id=4a327274&lang=less"

const __exports__ = script;

export default __exports__